

































import Vue from 'vue'
import moment from 'moment'
import AccessCodes, { AccessCodesStates } from '@/services/AccessCodes'
import { createAnonymousUser, observeUser } from '@/firebaseApp'
import restaurants, { RestaurantPublic } from '@/services/Restaurants'

export default Vue.extend({
  name: 'SubmitAccessCode',
  data() {
    return {
      error: null as string | null,
      accessCode: '',
      userId: '' as string | undefined,
      restaurantId: this.$router.currentRoute.params.restaurantId,
      restaurant: null as RestaurantPublic | null,
    }
  },
  // @ts-ignore
  async beforeRouteEnter(to, from, next) {
    const restaurant = await restaurants.getPublicRestaurant(to.params.restaurantId)
    if (!restaurant) {
      next({ name: 'home', params: { lang: to.params.lang } })
    }

    // @ts-ignore
    to.meta.props = { restaurant }
    next()
  },
  created() {
    // The navigation guard already got the restaurant
    // and passes it in the routa meta
    this.restaurant = this.$route.meta.props.restaurant
  },
  mounted() {
    // Focus on the input field
    const ref = this.$refs.accessCode as HTMLInputElement
    if (ref) {
      ref.focus()
    }

    // Fill access code if available
    const code = this.getAccesCode()
    if (code) {
      this.accessCode = code
    }

    observeUser(user => (this.userId = user?.uid))
  },
  computed: {
    localStorageKey() {
      return `accescode-${this.restaurantId}`
    },
    envString() {
      // @ts-ignore
      return process.env.NODE_ENV === 'development' ? process.env.NODE_ENV : null
    },
  },
  methods: {
    checkCode(evt: KeyboardEvent) {
      const isBackspace = evt.key === 'Backspace'
      if (isBackspace && this.accessCode.length === 5) {
        this.accessCode = this.accessCode.slice(0, 4)
      } else if (isBackspace && this.accessCode.length === 10) {
        this.accessCode = this.accessCode.slice(0, 9)
      } else if (!evt.key.toUpperCase().match(/[A-Z0-9-]/)) {
        evt.preventDefault()
      }
    },
    formatCode() {
      // Clean
      const code = this.accessCode.toUpperCase().replace(/[^A-Z0-9]/g, '')

      // Insert -
      const codeArr = Array.from(code)
      if (codeArr.length >= 4) {
        codeArr.splice(4, 0, '-')
      }
      if (codeArr.length >= 9) {
        codeArr.splice(9, 0, '-')
      }

      // Replace
      this.accessCode = codeArr.join('')
    },
    async submit() {
      this.error = null
      const code = this.accessCode.toUpperCase()
      if (!this.userId) {
        // There is no userId yet (so no loggedin admin, owner or staff
        // So create an anonymous
        await createAnonymousUser()
      }
      const status = await AccessCodes.check(this.restaurantId, code)

      if (status === AccessCodesStates.Unknown) {
        this.error =
          'Deze toegangscode is incorrect, controleer de toegangscode en probeer het opnieuw'
      } else if (status === AccessCodesStates.Expired) {
        this.error = 'Deze toegangscode is verlopen'
      } else if (status === AccessCodesStates.NotYetValid) {
        this.error = 'Deze toegangscode is niet geldig'
      }

      if (this.error) {
        return
      } else {
        this.setAccescode()
      }

      this.$router.push({
        name: 'permissions',
        params: { restaurantId: this.restaurantId, accessCode: this.accessCode },
      })
    },
    setAccescode() {
      const validTill = moment()
        .add(1, 'days')
        .hour(11)
        .minute(0)

      // @ts-ignore
      window.localStorage.setItem(
        this.localStorageKey,
        JSON.stringify({
          code: this.accessCode.toUpperCase(),
          validTill: validTill.toISOString(true),
        })
      )
    },
    getAccesCode() {
      if (this.$route.query.accessCode) {
        return this.$route.query.accessCode
      }

      const objStr = window.localStorage.getItem(this.localStorageKey)
      if (!objStr) {
        return null
      }

      const obj = JSON.parse(objStr)
      const isCodeStillValid = moment() < moment(obj.validTill)
      if (isCodeStillValid) {
        return obj.code
      }
      window.localStorage.removeItem(this.localStorageKey)
      return null
    },
  },
})
